var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "formContainer",
      staticClass: "container-big mx-auto prelative",
      attrs: { id: "formContainer" }
    },
    [
      _c("preloader", {
        staticClass: "preloader prelative",
        attrs: { display: _vm.loading }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "pfixed white-bkg third-form-nav py-3 px-5 flex-level flex-end span_12 zi-2"
        },
        [
          _c("CompassButton", {
            attrs: {
              label: _vm.$t.__("common.actions.cancel"),
              type: "secondary",
              "data-bot": _vm.getDatabot("cancel", _vm.current, "bottom", "btn")
            },
            on: {
              click: function($event) {
                return _vm.goBack()
              }
            }
          }),
          _vm._v(" "),
          _c("CompassButton", {
            staticClass: "ml-2",
            attrs: {
              label: _vm.labelSaveAndAction,
              type: "secondary",
              "data-bot": _vm.getDatabot(
                _vm.databotKey,
                _vm.current,
                "bottom",
                "btn"
              )
            },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.saveAndAction(_vm.current, "reset")
              }
            }
          }),
          _vm._v(" "),
          _c("CompassButton", {
            staticClass: "ml-2",
            attrs: {
              label: _vm.$t.__("common.actions.save"),
              type: "primary",
              "data-bot": _vm.getDatabot("save", _vm.current, "bottom", "btn")
            },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.saveAndAction(_vm.current, "redirection")
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("h1", { staticClass: "my-0" }, [_vm._t("title")], 2),
      _vm._v(" "),
      _vm.canBack
        ? _c(
            "a",
            {
              staticClass: "link mr-2 flex-level ln-20 mt-1",
              on: {
                click: function($event) {
                  return _vm.goBack()
                }
              }
            },
            [
              _c("i", { staticClass: "icon-arrow-back mr-1" }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.goBackTxt))])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: _vm.current,
          staticClass: "flex-row jc-space",
          attrs: {
            model: _vm.getModel,
            rules: _vm.getRules,
            "label-position": "top"
          }
        },
        [
          _c("div", { staticClass: "third-form" }, [_vm._t("default")], 2),
          _vm._v(" "),
          _c("form-side-params", {
            ref: "thirdFormParams",
            attrs: { entity: _vm.current }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }